var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 23,
    viewBox: "0 0 18 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 4.00617H7.25C5.85761 4.00617 4.52225 4.39173 3.53769 5.07805C2.55312 5.76436 2 6.69521 2 7.6658C2 8.6364 2.55312 9.56724 3.53769 10.2536C4.52225 10.9399 5.85761 11.3254 7.25 11.3254H10.75C12.1424 11.3254 13.4777 11.711 14.4623 12.3973C15.4469 13.0836 16 14.0145 16 14.9851C16 15.9557 15.4469 16.8865 14.4623 17.5728C13.4777 18.2592 12.1424 18.6447 10.75 18.6447H2M9 18.6447V21.0845M9 1.56641V4.00617",
    stroke: "#04758E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.c883740f433320dc51a3547bb6b40f5c.svg";
export { ForwardRef as ReactComponent };